import React__default, { useCallback } from 'react';
import { YouMayAlsoLikeArticle } from './you-may-also-like-article.esm.js';

var Anchor = function Anchor(props) {
  var article = props.article,
    articleClickHandler = props.articleClickHandler;
  var handelOnClick = useCallback(function (e) {
    e.preventDefault();
    articleClickHandler(e, article.id, article.title);
  }, [article, articleClickHandler]);
  return /*#__PURE__*/React__default.createElement("a", {
    className: "mr-6 w-1/3 grow",
    href: article.url,
    onClick: handelOnClick
  }, /*#__PURE__*/React__default.createElement(YouMayAlsoLikeArticle, {
    article: article
  }));
};
var YouMayAlsoLikeArticles = function YouMayAlsoLikeArticles(props) {
  var articles = props.articles,
    articleClickHandler = props.articleClickHandler;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "flex flex-row justify-between [&>*:last-child]:mr-0",
    "automation-id": "YouMayAlsoLikeArticles"
  }, articles.map(function (article, idx) {
    return /*#__PURE__*/React__default.createElement(Anchor, {
      key: "".concat(article.url, "-").concat(idx),
      article: article,
      articleClickHandler: articleClickHandler
    });
  }));
};

export { YouMayAlsoLikeArticles };
//# sourceMappingURL=you-may-also-like-articles.esm.js.map
